function encrypt(input, iterations) {
  const salt = generateSalt(8); // 动态生成盐值
  let result = input;

  for (let i = 0; i < iterations; i++) {
      result = salt + result; // 每次编码前添加盐
      result = btoa(result); // Base64 编码
  }

  // 将盐值插入位置
  const position = 16;
  result = result.substring(0, position) + salt + result.substring(position);

  return result; // 返回密文
}

// 生成随机盐
function generateSalt(length) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let salt = "";

  for (let i = 0; i < length; i++) {
      salt += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return salt;
}

const iterations = 5;

export default (text) => encrypt(text, iterations)